import { gpHome } from '../app';
import { AccountsService } from '../services/accounts-service';

interface IConfirmEmailScope extends ng.IScope {
    confirmationSuccessful: boolean;
    confirmationResending: boolean;
    confirmationResent: boolean;
    confirmationResentError: boolean;
    confirmationError: string;
    confirming: boolean;
    resendEmail(): void;
}

gpHome.controller(
    'confirmemailController',
    ['$scope', '$location', 'accountsService', '$routeParams',
        function ($scope: IConfirmEmailScope, $location: ng.ILocationService, accountsService: AccountsService, $routeParams: ng.route.IRouteParamsService) {

            let userId = $routeParams['userId'];
            let code = $routeParams['code'];

            $scope.confirming = true;

            $scope.resendEmail = () => {
                $scope.confirmationResending = true;

                accountsService.resendEmail(userId)
                    .then(() => $scope.confirmationResent = true)
                    .catch(value => $scope.confirmationResentError = value)
                    .finally(() => $scope.confirmationResending = false)
                    ;
            };

            accountsService.confirmEmail(userId, code)
                .then(value => $scope.confirmationSuccessful = true)
                .catch(value => $scope.confirmationError = value)
                .finally(() => $scope.confirming = false);
        }]);
